import { useState, useEffect } from 'react';
import { transactionAPI } from '../services/api';

interface UseFailedTransactionsResult {
  hasFailedTransactions: boolean;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useFailedTransactions = (memberProfileId?: string): UseFailedTransactionsResult => {
  const [hasFailedTransactions, setHasFailedTransactions] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFailedTransactions = async () => {
    if (!memberProfileId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Fetch transactions with failed status
      const response = await transactionAPI.getMyTransactions({
        status: 'failed',
        limit: 1 // We only need to know if there's at least one
      });

      // Backend returns { transactions: [...], total: number, ... }
      const transactions = response.data?.transactions || [];

      setHasFailedTransactions(transactions.length > 0);
    } catch (err: any) {
        console.error('Error fetching failed transactions:', err);
        setError(err?.response?.data?.message || 'Failed to check transaction status');
        setHasFailedTransactions(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFailedTransactions();
  }, [memberProfileId]);

  return {
    hasFailedTransactions,
    loading,
    error,
    refetch: fetchFailedTransactions
  };
};
